<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [HandledDevice]
 * Плитка сдаваемого устройства
 */

// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { fireIcon } from "@/public/svg/fire-icon";
// Components
import Button from "@/ui/button/button.vue";
// Icons
import EditIcon from "@/ui/icons/edit.vue";
import parseStringPrice from "~/tiw/helpers/parseStringPrice/index.js";
import { useHowYouRateDeviceStore } from "~/tiw/stores/howYouRateDevice/howYouRateDevice.js";
import { useTIWStore } from "~/tiw/stores/tiw/tiw.js";

// Types
import type { I_HandedDevice } from "./handedDevice.types.ts";

const props = defineProps<I_HandedDevice>();

const TIWStore = useTIWStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();

function onEditHandler() {
    if (props.onEdit) {
        props.onEdit();
    }
}
</script>

<template>
    <div
        class="tiw__handedDevice"
        :class="{
            tiw__handedDevice_noGrade: props.deviceTerminated,
        }"
    >
        <div class="tiw__handedDevice__container">
            <Button
                class="tiw__handedDevice__edit"
                type="button"
                variant="unset"
                @click="onEditHandler"
            >
                <EditIcon />
            </Button>
            <figure class="tiw__handedDevice__figure">
                <img
                    class="tiw__handedDevice__image"
                    :src="props.devicePreview"
                    alt="Handed device"
                />
            </figure>

            <div class="tiw__handedDevice__body">
                <p class="tiw__handedDevice__title">
                    {{ useTranslate("tiw__handedDevice__title") }}
                </p>
                <ul v-if="props.deviceChain" class="tiw__handedDevice__device-chain">
                    <li v-for="(chainElement, ind) in props.deviceChain" :key="`chain_${ind}`">
                        <span>{{ chainElement }}</span>
                    </li>
                </ul>
                <div v-if="props.deviceState" class="tiw__handedDevice__info-block">
                    <p>{{ useTranslate("tiw__handedDevice__condition") }}</p>
                    <p>
                        <b>{{ props.deviceState }}</b>
                    </p>
                </div>
                <hr v-if="props.devicePrice" class="tiw__handedDevice__info-block__line" />
                <div v-if="props.devicePrice" class="tiw__handedDevice__info-block">
                    <p>{{ useTranslate("tiw__handedDevice__valuation") }}</p>
                    <p>
                        <!-- <b>{{ useTranslate("tiw__calculatedDevice__price_list_tradeInSale_from")
              .replace("[[PRICE]]", props.devicePrice)
              .replace(
                "[[CURRENCY]]",
                HowYouRateDeviceStore.registeringDeviceData.currency,
              ) }}</b> -->
                        <s v-if="!TIWStore.HOLD" class="tiw__handedDevice__info-block__discount"
                            >{{ props.devicePrice }}
                            {{ HowYouRateDeviceStore.registeringDeviceData.currency }}</s
                        >
                        <b>
                            {{
                                TIWStore.HOLD
                                    ? props.devicePrice
                                    : ((parseStringPrice(props.devicePrice) / 100) * 70).toFixed()
                            }}
                            {{ HowYouRateDeviceStore.registeringDeviceData.currency }}</b
                        >
                    </p>
                </div>
            </div>
        </div>

        <div
            v-if="HowYouRateDeviceStore.registeringDeviceData.additionalDiscountValue"
            class="tiw__calculatedDevice__price-list__row tiw__calculatedDevice__price-list__row_action-sale"
        >
            <div
                class="tiw__calculatedDevice__price-list__row__data tiw__calculatedDevice__price-list__row__data_key tiw__calculatedDevice__price-list__row__data_key_action"
            >
                <figure v-html="fireIcon"></figure>

                <div class="tiw__calculatedDevice__price-list__row__data__actionSale">
                    <p>
                        {{
                            // useTranslate('tiw__calculatedDevice__price_list_additionalSale')
                            useTranslate("tiw__handedDevice__samsungS26Bonus")
                        }}
                    </p>
                </div>
            </div>
            <div
                class="tiw__calculatedDevice__price-list__row__data tiw__calculatedDevice__price-list__row__data_value"
            >
                <span>
                    {{ HowYouRateDeviceStore.registeringDeviceData.additionalDiscountValue }}&nbsp;
                </span>
                <span>
                    {{ HowYouRateDeviceStore.registeringDeviceData.currency }}
                </span>
            </div>
        </div>

        <div v-if="props.deviceNoGrade" class="tiw__handedDevice__no-grade">
            <span>
                {{ useTranslate("tiw__handedDevice__unknownGrade") }}
            </span>
        </div>
        <div v-if="props.deviceTerminated" class="tiw__handedDevice__no-grade">
            <span>
                {{ useTranslate("tiw__handedDevice__deviceTerminated") }}
            </span>
        </div>
    </div>
</template>

<style lang="scss" src="./handedDevice.scss"></style>
